import React from 'react';

import { Box, Typography } from '@mui/material';

import { ICandidateDetails } from '@types';
import { candidateSubtitle, isTruthy } from '@utils';
import { CountryFlag } from 'components/common/CountryFlag/CountryFlag';
import { RecommendedStar } from 'components/common/RecommendedStar/RecommendedStar';

interface ICandidateDetailsHeader {
  data?: ICandidateDetails | null;
  variant?: 'page' | 'drawer';
}

export const CandidateDetailsHeader: React.FC<ICandidateDetailsHeader> = ({
  data,
  variant = 'page',
}) => {
  const isDrawer = variant === 'drawer';
  const fullName = data
    ? [data.profile?.firstName, data.profile?.lastName]
        .filter(isTruthy)
        .join(' ')
        .trim() || 'Candidate'
    : '';
  const subtitle = data
    ? candidateSubtitle(data, { withCountry: isDrawer })
    : '';

  return (
    <Box minWidth={0} flexGrow={isDrawer ? 1 : undefined}>
      <Typography
        variant={isDrawer ? 'h3' : 'h2'}
        component="h2"
        display="flex"
        flexWrap={isDrawer ? 'nowrap' : 'wrap'}
        alignItems="center"
        gap={1}
      >
        <CountryFlag
          country={data?.profile?.country ?? ''}
          width={20}
          sx={{ marginRight: 0, display: 'flex' }}
        />
        <Typography
          component="span"
          variant="inherit"
          minWidth={0}
          noWrap={isDrawer}
        >
          {fullName}
        </Typography>
        {Boolean(data?.isStarred) && <RecommendedStar />}
      </Typography>
      {Boolean(subtitle) && (
        <Typography
          variant={isDrawer ? 'caption' : 'body1'}
          component="p"
          color="text.secondary"
          noWrap={isDrawer}
          mt={isDrawer ? 0.25 : 0}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
